import React from 'react';

const NotFound = () => <h3>Page not found</h3>;

export default NotFound;
